/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  GuestPrivsFull,
  GuestPrivsFullOptional,
  GuestPrivsFullMetaI,
  GuestPrivsFullTrackedI,
} from "./guest-privs-full";
import { GuestPrivsFullTracked, GuestPrivsFullMeta } from "./guest-privs-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipRef,
  MembershipRefOptional,
  MembershipRefMetaI,
  MembershipRefTrackedI,
} from "./membership-ref";
import { MembershipRefTracked, MembershipRefMeta } from "./membership-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface PurchaseGuestPrivilegesDTO
 */
export interface PurchaseGuestPrivilegesDTOOptional extends GuestPrivsFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  startDate?: Date;
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  membershipId?: MembershipRefOptional;
}

export interface PurchaseGuestPrivilegesDTO
  extends PurchaseGuestPrivilegesDTOOptional, GuestPrivsFull {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  price?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchaseDate?: Date;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  voidCloseId?: number;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  startDate?: Date;
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  membershipId?: MembershipRef;
}

export interface PurchaseGuestPrivilegesDTOTrackedI extends GuestPrivsFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  voidCloseId?: number;
  voidCloseIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  startDate?: Date;
  startDateIsSet: boolean;
  /**
   *
   * @type {MembershipRef}
   * @memberof PurchaseGuestPrivilegesDTO
   */
  membershipId?: MembershipRefTrackedI;
  membershipIdIsSet: boolean;
}

transformDatesMap.set(
  "PurchaseGuestPrivilegesDTO",
  function (model: PurchaseGuestPrivilegesDTO) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    if (typeof model.startDate == "string")
      model.startDate = new Date(model.startDate);
    const transformDatesmembershipId = transformDatesMap.get("MembershipRef");
    if (transformDatesmembershipId && model.membershipId) {
      transformDatesmembershipId(model.membershipId);
    }
  },
);

export type PurchaseGuestPrivilegesDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  voidCloseId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  startDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  membershipId: PropertyMeta<MembershipRefMetaI>;
}>;

export var PurchaseGuestPrivilegesDTOMeta: PurchaseGuestPrivilegesDTOMetaI =
  {} as PurchaseGuestPrivilegesDTOMetaI;
PurchaseGuestPrivilegesDTOMeta = typeMeta("PurchaseGuestPrivilegesDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  voidCloseId: propertyMeta(
    "voidCloseId",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  startDate: propertyMeta("startDate", false, false, false, MetaTypesBase.Date),
  membershipId: propertyMeta(
    "membershipId",
    false,
    false,
    false,
    MembershipRefMeta,
  ),
});

const metaI = PurchaseGuestPrivilegesDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([GuestPrivsFullMeta]);
  metaI.isDeleted.inheritedFrom = GuestPrivsFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = GuestPrivsFullMeta.isNew;
  metaI.assignId.inheritedFrom = GuestPrivsFullMeta.assignId;
  metaI.price.inheritedFrom = GuestPrivsFullMeta.price;
  metaI.purchasableState.inheritedFrom = GuestPrivsFullMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = GuestPrivsFullMeta.purchaseDate;
  metaI.voidCloseId.inheritedFrom = GuestPrivsFullMeta.voidCloseId;
  metaI.startDate.inheritedFrom = GuestPrivsFullMeta.startDate;
  metaI.membershipId.inheritedFrom = GuestPrivsFullMeta.membershipId;
});

export class PurchaseGuestPrivilegesDTOTracked
  extends GuestPrivsFullTracked
  implements PurchaseGuestPrivilegesDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  voidCloseId__I?: number = undefined;
  voidCloseIdIsSet: boolean = false;
  set voidCloseId(v: undefined | number) {
    if (v !== undefined) {
      this.voidCloseId__I = v;
      this.voidCloseIdIsSet = true;
    } else {
      this.voidCloseId__I = v || undefined;
      this.voidCloseIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get voidCloseId() {
    return this.voidCloseId__I;
  }
  startDate__I?: Date = undefined;
  startDateIsSet: boolean = false;
  set startDate(v: undefined | Date) {
    if (v !== undefined) {
      this.startDate__I = v;
      this.startDateIsSet = true;
    } else {
      this.startDate__I = v || undefined;
      this.startDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get startDate() {
    return this.startDate__I;
  }
  membershipId__I?: MembershipRefTracked = undefined;
  membershipIdIsSet: boolean = false;
  set membershipId(v: undefined | MembershipRefTracked) {
    if (v !== undefined) {
      this.membershipId__I = v;
      this.membershipIdIsSet = true;
    } else {
      this.membershipId__I = v || undefined;
      this.membershipIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get membershipId() {
    return this.membershipId__I;
  }
  constructor(
    config?: PurchaseGuestPrivilegesDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.membershipId?.setIds();
  }
  assignFrom(
    config: PurchaseGuestPrivilegesDTOOptional,
    options?: AssignOptions,
  ): PurchaseGuestPrivilegesDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.voidCloseId &&
      this.voidCloseIdApplyFilter(optionsRequired.filter)
    ) {
      this.voidCloseId = config.voidCloseId;
      if (optionsRequired.unassign) this.voidCloseIdIsSet = false;
      else this.voidCloseIdIsSet = true;
    }
    if (config.startDate && this.startDateApplyFilter(optionsRequired.filter)) {
      this.startDate = config.startDate;
      if (optionsRequired.unassign) this.startDateIsSet = false;
      else this.startDateIsSet = true;
    }
    if (
      config.membershipId &&
      this.membershipIdApplyFilter(optionsRequired.filter)
    ) {
      this.membershipId = new MembershipRefTracked(
        config.membershipId,
        options,
      );
      if (optionsRequired.unassign) this.membershipIdIsSet = false;
      else this.membershipIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PurchaseGuestPrivilegesDTOTrackedI {
    const cloned = {} as PurchaseGuestPrivilegesDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.voidCloseIdIsSetDeep() &&
      this.voidCloseIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.voidCloseIdIsSet = true;
      cloned.voidCloseId = this.voidCloseId;
    } else {
      //cloned.voidCloseIdIsSet = false
    }
    if (
      this.startDateIsSetDeep() &&
      this.startDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startDateIsSet = true;
      cloned.startDate = this.startDate;
    } else {
      //cloned.startDateIsSet = false
    }
    if (
      this.membershipIdIsSetDeep() &&
      this.membershipIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.membershipIdIsSet = true;
      cloned.membershipId = this.membershipId?.removeUnset(filter);
    } else {
      //cloned.membershipIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PurchaseGuestPrivilegesDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.voidCloseIdApplyFilter(filter)) this.voidCloseIdIsSet = false;

    if (!this.startDateApplyFilter(filter)) this.startDateIsSet = false;

    if (!this.membershipIdApplyFilter(filter)) this.membershipIdIsSet = false;
    this.membershipId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.isDeleted,
      PurchaseGuestPrivilegesDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.isNew,
      PurchaseGuestPrivilegesDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.assignId,
      PurchaseGuestPrivilegesDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.price,
      PurchaseGuestPrivilegesDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.purchasableState,
      PurchaseGuestPrivilegesDTOMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.purchaseDate,
      PurchaseGuestPrivilegesDTOMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  voidCloseIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.voidCloseId,
      PurchaseGuestPrivilegesDTOMeta,
      this.voidCloseId,
      this,
    );
  }
  voidCloseIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.voidCloseIdIsSet && this.voidCloseIdApplyFilter(filter))
      return true;

    return false;
  }
  startDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.startDate,
      PurchaseGuestPrivilegesDTOMeta,
      this.startDate,
      this,
    );
  }
  startDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startDateIsSet && this.startDateApplyFilter(filter)) return true;

    return false;
  }
  membershipIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PurchaseGuestPrivilegesDTOMeta.membershipId,
      PurchaseGuestPrivilegesDTOMeta,
      this.membershipId,
      this,
    );
  }
  membershipIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.membershipIdIsSet && this.membershipIdApplyFilter(filter))
      return true;
    return this.membershipId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.voidCloseIdIsSetDeep(filter)) return true;
    if (this.startDateIsSetDeep(filter)) return true;
    if (this.membershipIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
